import Navbar from './Navbar';

const Header = (props) => {
  return (
    <Navbar company={props.company} />
  );
};

export default Header;